import { EnvironmentConfiguration } from '../app/dtos/environment-configuration.model';

export const environment: EnvironmentConfiguration = {
  production: false,
};
